import React from "react";
import { FontIcon } from "@fluentui/react";
import { Button, Dialog, DialogBody, DialogSurface, DialogTitle } from "@fluentui/react-components";
import { useFeedback } from "../../hooks/useFeedback";
import { modalStyles, useDialogTitleStyles } from "../../router/AuthorizedRoutes/PriorityContacts/styles";
import { feedbackHeaderClass, feedbackTitleClass } from "./styles";
import FeedbackForm from "./FeedbackForm";


const Feedback = ({ onFormSubmit, isOpenFeedback, setIsOpenFeedback }) => {
  const {
    state,
    selectedFeedbackType,
    isPending,
    setFeedbackType,
    setComment,
    submitFeedback,
    discardFeedback,
    enableToDiscard,
    toggleDiscardFeedback,
    hideModalFeedback,
  } = useFeedback({ onFormSubmit, setIsOpenFeedback });

  const dialogTitleStyles = useDialogTitleStyles();

  return (
    <>
      {/* Feedback form dialog */}
      <Dialog
        open={isOpenFeedback && !discardFeedback}
        onOpenChange={(_, data) => { if (!data.open) toggleDiscardFeedback(); }}
        modalType="non-modal"
      >
        <DialogSurface className={modalStyles.container}>
          <div className={feedbackHeaderClass}>
            <div className={feedbackTitleClass}>Send us feedback</div>
            <Button
              appearance="subtle"
              icon={<FontIcon iconName="Cancel" />}
              aria-label="Close popup"
              onClick={toggleDiscardFeedback}
            />
          </div>
          <FeedbackForm
            comment={state.comment}
            selectedFeedbackType={selectedFeedbackType}
            isPending={isPending}
            onFeedbackTypeChange={setFeedbackType}
            onCommentChange={setComment}
            onSubmit={submitFeedback}
          />
        </DialogSurface>
      </Dialog>

      {/* Discard confirmation dialog */}
      <Dialog
        open={enableToDiscard && discardFeedback}
        onOpenChange={(_, data) => { if (!data.open) hideModalFeedback(); }}
        modalType="non-modal"
      >
        <DialogSurface className={modalStyles.container}>
          <DialogBody>
            <DialogTitle
              as="h3"
              className={dialogTitleStyles.title}
              action={
                <Button
                  appearance="subtle"
                  icon={<FontIcon iconName="Cancel" />}
                  aria-label="Close Modal"
                  onClick={hideModalFeedback}
                />
              }
            >
              Are you sure you want to discard this feedback?
            </DialogTitle>
            <div className={modalStyles.body}>
              <Button onClick={hideModalFeedback} className={modalStyles.btnClass}>
                Yes
              </Button>
              <Button appearance="primary" onClick={toggleDiscardFeedback} className={modalStyles.btnClass}>
                No
              </Button>
            </div>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
};

export default Feedback;
